// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getLicensePartnerById } from 'app/constants/enums/LicensePartner/main';

/* eslint-disable max-len */
export const ASSOCIATED_PRESS = getLicensePartnerById('associatedPress');
/* eslint-enable max-len */
